import { jsx as _jsx } from "react/jsx-runtime";
import Slider from 'rc-slider';
import { twMerge } from 'tailwind-merge';
import { useTestId } from '../../hooks';
import { forwardRefWithName } from '../../utils';
function RangeSliderComponent(props, ref) {
    const { className, range, value, onChange, disabled, step = 100, testId = 'slider', marks, } = props;
    const tid = useTestId(testId, props);
    const handleChange = (value) => {
        const newValue = value;
        onChange(newValue);
    };
    const classList = twMerge('w-full relative', className);
    const min = range[0];
    const max = range[1];
    return (_jsx("div", Object.assign({ ref: ref, className: classList }, tid(), { children: _jsx(Slider, { range: true, allowCross: false, className: "slider", min: min, max: max, value: value, onChange: handleChange, disabled: disabled, step: step, marks: marks }) })));
}
export const RangeSlider = forwardRefWithName(RangeSliderComponent);
//# sourceMappingURL=RangeSlider.js.map